import React from "react";
import trialImage from "../assets/Trial3.jpg";
import ArticleTile from "../components/ArticleTile";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

function Home() {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Render ArticleTile for mobile sizes (when screen is less than 385px)

  return (
    <div className="home-container">
      {/* Main News Section */}
      {/* Main News Section */}
      <div
        style={{
          display: "flex",
          maxHeight: "75vh",
          color: "white",
          position: "relative",
          width: "100%",
        }}
      >
        {/* News Info Section */}
        <div
          style={{
            background: "black",
            width: "100%",
            padding: "20px",
            borderRadius: "4px 0px 0px 4px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "2px",
              fontFamily: "Roboto",
            }}
          >
            <div
              style={{ color: "red", fontWeight: 600, letterSpacing: "1.2px" }}
            >
              Breaking News
            </div>
            <div className="vertical-line"></div>
            <div style={{ color: "#7f7f7f", fontSize: "12px" }}>
              {" "}
              1 Hour Ago
            </div>
          </div>
          {screenWidth > 185 && screenWidth <= 820 && (
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <Link to={"/community-service"}>
                <div
                  style={{
                    color: "white",
                    fontSize: "2.82vw",
                    fontWeight: "bold",
                    textAlign: "left",
                  }}
                >
                  HORROR CONTINUES
                </div>
              </Link>
            </div>
          )}
        </div>

        {/* Title with Overlay (only visible on larger screens) */}
        {screenWidth >= 821 && (
          <div className="title-overlay">
            <Link to={"/community-service"} style={{ color: "white" }}>
              HORROR CONTINUES: From Cheesecake to Checkmate: Feucht Ducks
              Desserts and Sorrys Alike
            </Link>
          </div>
        )}

        {/* Title below Breaking News when screen is between 385px and 621px */}

        {/* Image */}
        <Link to={"/community-service"} style={{ color: "white" }}>
          <img
            src={trialImage}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "0px 4px 4px 0px",
            }}
          />
        </Link>
      </div>
      {/* Conditional ArticleTile Rendering on Mobile */}

      {/* Article Tiles */}
      <div className="articles-grid">
        <ArticleTile
          imageName="Vehicle.jpg"
          title="Woman Left Gasping for Air After Seat Sabotage by Local Miscreants"
          path="/vehicle"
        />
        <ArticleTile
          imageName="Skye.jpg"
          title="Adult Man in 5th Consecutive Day of Carrying Paw Patrol Plush, Town Officials Begin Emergency Talks "
          path="/skye"
        />
        <ArticleTile
          imageName="Bike_Stretch.jpg"
          title="Illinois Man Mistakes Charity Bike Ride for Monster Truck Rally, Flattens 75-Year-Old"
          path="/biking"
        />
        <ArticleTile
          imageName="Trailhead32.jpg"
          title="Trail Signs and Troublemakers: Will Feucht Resurfaces in Glacier National Park Selfie Scandal"
          path="/hiking"
        />
      </div>
    </div>
  );
}

export default Home;

/* import trialImage from '../assets/Trial2.jpg';
import ArticleTile from '../components/ArticleTile';
import { Link } from 'react-router-dom';

function Home(){
    return (      
    <div style={{padding: '20px'}}>
      <div style={{display: 'flex', maxHeight: '75vh', color: 'white'}}>
        <div style={{background: 'black', padding: '20px'}}>
          <div style={{display: 'flex', flexDirection: 'row', gap: '2px', fontFamily: 'Roboto'}}>
            <div style={{color: 'red', fontWeight: 600, letterSpacing: '1.2px'}}>Breaking News</div>
            <div className='vertical-line'></div>
            <div style={{color: '#7f7f7f', fontSize: '12px'}}> 1 Hour Ago</div>
          </div>
          <Link to={'/trial'}><div style={{color: 'white', fontSize: '3pc', marginTop: '8px', textAlign: 'left', height: 'calc(100% - 5px)', display: 'flex', alignItems: 'center'}}>HORROR AT COURT: A courtroom reckoning with the darkest corners of humanity: the fight for justice begins
      </div>
      </Link>
        </div>
        <Link to={'/trial'} style={{color: 'white'}}><img src={trialImage} style={{maxHeight: 'calc(100% - 1px)', maxWidth: '100vh'}}></img></Link>
      </div>
      <div style={{display: 'flex', margin: '15px 0px', flexWrap: 'wrap'}}>
      <ArticleTile style={{maxWidth: '25%'}} imageName='Waitress.jpg' title={'Repeat Offender Disrespects Church Waitress'} path={'/waitress'}></ArticleTile>
      <div class='vertical-line' style={{backgroundColor: '#d9d9d9', marginBottom: '15px'}}></div>
      <ArticleTile style={{maxWidth: '25%'}} imageName='Road.jpg' title={'Local transplants bond over inciting traffic chaos'} path={'/road'}></ArticleTile>
      <div class='vertical-line' style={{backgroundColor: '#d9d9d9', marginBottom: '15px'}}></div>
      <ArticleTile style={{maxWidth: '25%'}} imageName='Hike_Horizontal.jpg' title={'Convict escapes to Switzerland, while victims languish at home'} path={'/hike'}></ArticleTile>
      <div class='vertical-line' style={{backgroundColor: '#d9d9d9', marginBottom: '15px'}}></div>
      <ArticleTile style={{maxWidth: '25%'}} imageName='Ski_Flipped.jpg' title={'Illinoisan Native cited as nuisance on lake'} path={'/ski'}></ArticleTile>
      </div>
      </div>
      );
}

export default Home; */
